import { useQuery } from '@tanstack/react-query'

import { getSearchlightResults } from './searchlight.service'

export const useSearchlight = (query: string) => {
  return useQuery({
    enabled: !!query,
    queryKey: ['searchlight', query],
    queryFn: async () => {
      const response = await getSearchlightResults(query)

      return response.items
    },
  })
}
